import api from './api';

const cache = {};

export const categoryService = {
  async getRoots() {
    if (cache.roots) return cache.roots;
    const res = await api.get('/categories');
    cache.roots = res.data;
    return res.data;
  },

  async getChildren(parentId) {
    const key = `children_${parentId}`;
    if (cache[key]) return cache[key];
    const res = await api.get(`/categories/${parentId}/children`);
    cache[key] = res.data;
    return res.data;
  },

  async search(query) {
    const res = await api.get('/categories/search', { params: { q: query } });
    return res.data;
  },
};
